import React, { useEffect } from "react";
import { MapContainer, TileLayer, CircleMarker, Tooltip, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { categories, cityCenter } from "../mock";

const colorFor = (categoryId) =>
  categories.find((c) => c.id === categoryId)?.color || "#3d5a80";

// Keeps the map in sync when the active place changes
const FlyToActive = ({ places, activeId }) => {
  const map = useMap();
  useEffect(() => {
    if (activeId) {
      const p = places.find((x) => x.id === activeId);
      if (p) map.panTo([p.lat, p.lng], { animate: true, duration: 0.6 });
    }
  }, [activeId, places, map]);
  return null;
};

const MapView = ({ places, activeId, onHover }) => {
  return (
    <MapContainer
      center={[cityCenter.lat, cityCenter.lng]}
      zoom={12}
      zoomControl={true}
      className="h-full w-full"
      style={{ background: "#eae7e1" }}
    >
      <TileLayer
        attribution='&copy; <a href="https://carto.com/">CARTO</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
      />
      <FlyToActive places={places} activeId={activeId} />
      {places.map((p) => {
        const active = p.id === activeId;
        return (
          <CircleMarker
            key={p.id}
            center={[p.lat, p.lng]}
            radius={active ? 9 : 6}
            pathOptions={{
              color: "#ffffff",
              weight: 2,
              fillColor: colorFor(p.category),
              fillOpacity: 1,
            }}
            eventHandlers={{
              mouseover: () => onHover && onHover(p.id),
              mouseout: () => onHover && onHover(null),
            }}
          >
            <Tooltip
              direction="top"
              offset={[0, -6]}
              opacity={1}
              permanent={active}
              className="dilli-tooltip"
            >
              {p.name}
            </Tooltip>
          </CircleMarker>
        );
      })}
    </MapContainer>
  );
};

export default MapView;
